





























































































































































































































































import Vue from 'vue';
// import VueGoogleCharts from 'vue-google-charts'
import Chart from 'chart.js'
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import { conection } from '@/plugins/utils/conectionUtils';
import { pad } from '@/plugins/utils/utils';
import { Iterapeuta } from '@/plugins/utils/terapeutasUtils';

interface TerapeutaStats extends Iterapeuta {
  total: number;
  presencas: number;
}

@Component({
  components: {
    TitleArea
  }
})
export default class Estatisticas extends Vue {
  primaryColor = this.$vuetify.theme.themes.light.primary;
  
  
  date = new Date();
  today = this.date.getFullYear()+"-"+ pad(this.date.getMonth()+1, 2)+"-"+pad(this.date.getDate(), 2);
  
  date_ini: string = this.today;
  date_fim: string = this.today;

  menu_day_ini = false;
  menu_day_fim = false;

  terapeutas: TerapeutaStats[] = [];
  valores_totais: {
    total: number;
    dias: number;
    media_faltas: number;
    media_presencas: number;
    media_total: number;
    presencas: number;
    faltas_perc: number;
    presencas_perc: number;
    activos: number;
    altas: number;
    consultas: number;
    news: number;
  } | null = null;
  datas: {
    data: string;
    presencas: number;
    total: number;
    terapeutas: {
      total: number;
      presencas: number;
    }[];
  }[] = []; 
  week_values: {
    dias: number;
    total: number;
    presencas: number;
    media: number;
    presencas_media: number;
    presencas_perc: number;
    perc: number;
    day: string;
    day_index: number;
  }[] = [];
  colors: string[] = [];

  
  barChart: Chart | null = null;
  pieChart: Chart | null = null;
  weekBars: Chart | null = null;
  

  tabs_tratamentos = null;

  // created(){
    
  // }

  mounted(){
    // this.createChart();
    this.date.setDate(this.date.getDate()-7);
    this.date_ini = this.date.getFullYear()+"-"+ pad(this.date.getMonth()+1, 2)+"-"+pad(this.date.getDate(), 2);
    this.getEstatisticas(this.date_ini, this.date_fim);
  }

  getTratamentosData(){
    this.getEstatisticas(this.date_ini, this.date_fim);
  }

  getEstatisticas(data_ini: string, data_fim: string){
    this.$store.commit("setLoading",true);
    conection(
      "getEstatisticas.php",
      {data_inicio: data_ini, data_fim: data_fim},
      (resp) => {
        // console.log(resp);
        this.terapeutas = resp.terapeutas;
        this.datas = resp.dates;
        this.valores_totais = resp.valores_totais;
        this.week_values = resp.week_values;
        if(this.colors.length < this.terapeutas.length){
          this.colors = resp.colors
        }
        this.createChart();
      },
      () => {
        // console.log(err)
        this.$store.commit("setLoading",false);
      }
    );
  }

  changeTab(){
    setTimeout(() => {
      this.createChart();
    }, 150);
  }
  createChart() {
    const labels: string[] = [];
    const datasets: Chart.ChartDataSets[] = [];
    this.terapeutas.forEach((ter,i) => {

      const values: number[] = [];
      const values_t: number[] = [];  

      this.datas.forEach(data => {
        const ter_values = data.terapeutas[ter.id];
        values.push(ter_values.presencas);
        values_t.push(ter_values.total);
      });

      const dataset: Chart.ChartDataSets = {
        label: ter.nome,
        data: values,
        backgroundColor: this.colors[i]+"80",
        borderColor: this.colors[i],
        borderWidth: 1
      }
      const dataset_t: Chart.ChartDataSets = {
        label: ter.nome+" (Esperado)",
        data: values_t,
        backgroundColor: this.colors[i],
        borderColor: this.colors[i],
        borderWidth: 1,
        type: 'line',
        fill: false
      }
      datasets.push(dataset);
      datasets.push(dataset_t);

    });

    const values_totais: number[] = [];
    const values_totais_t: number[] = [];
    this.datas.forEach(item => {
      labels.push(item.data);
      values_totais.push(item.presencas);
      values_totais_t.push(item.total);
    });

    const dataset: Chart.ChartDataSets = {
      label: "Total",
      data: values_totais,
      backgroundColor: this.colors[this.terapeutas.length]+"80",
      borderColor: this.colors[this.terapeutas.length],
      borderWidth: 1
    }
    const dataset_t: Chart.ChartDataSets = {
      label: "Total (Esperado)",
      data: values_totais_t,
      backgroundColor: this.colors[this.terapeutas.length],
      borderColor: this.colors[this.terapeutas.length],
      borderWidth: 1,
      type: 'line',
      fill: false
    }
    datasets.push(dataset);
    datasets.push(dataset_t);

    const title_op: Chart.ChartTitleOptions = {
      display: true,
      text: '',
      fontSize: 20
    }
    
    title_op.text = 'Presenças / Esperado';
    const chartConf: Chart.ChartConfiguration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: title_op,
        legend: {
          display: true,
          position: 'bottom',
          align: 'start',
          labels: {
            boxWidth: 10,
            usePointStyle: true
          }
        },
        scales: {
          yAxes: [{ticks: {beginAtZero: true}}]
        }
      }
    }
    
    const canvas = document.getElementById('bars') as HTMLCanvasElement;
    if(this.barChart){
      this.barChart.destroy();
    }
    this.barChart = new Chart(canvas, chartConf)

    if(this.valores_totais){
      const canvasPie = document.getElementById('pie') as HTMLCanvasElement;
      title_op.text = 'Presenças vs Faltas (%)';
      const chartConfPie: Chart.ChartConfiguration = {
        type: 'pie',
        data: {
          labels: ['Faltas','Presenças'],
          datasets: [{
            data: [this.valores_totais.faltas_perc, this.valores_totais.presencas_perc],
            backgroundColor: [
              "#99000080",
              "#00990080"
            ]
          }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: title_op,
          legend: {
            display: true,
            position: 'bottom',
            align: 'center',
            labels: {
              boxWidth: 10,
              usePointStyle: true
            }
          },
        }
      }
      if(this.pieChart){
        this.pieChart.destroy();
      }
      this.pieChart = new Chart(canvasPie, chartConfPie)

    }

    if(this.week_values.length > 0){
      const canvasbar2 = document.getElementById('bars_week') as HTMLCanvasElement;

      const labels_week: string[] = [];
      const datasets_week: Chart.ChartDataSets[] = [];
      const valores_week: number[] = [];
      const valores_week_pres: number[] = [];
      this.week_values.forEach(item => {
        labels_week.push(item.day);
        valores_week.push(item.media);
        valores_week_pres.push(item.presencas_media);
      });
      
      const dataset_week: Chart.ChartDataSets = {
        label: "Presencas",
        data: valores_week_pres,
        backgroundColor: this.colors[0]+"80",
        borderColor: this.colors[0],
        borderWidth: 1
      }

      const dataset_week_t: Chart.ChartDataSets = {
        label: "Esperado",
        data: valores_week,
        backgroundColor: this.colors[0],
        borderColor: this.colors[0],
        borderWidth: 1,
        type: 'line',
        fill: false
      }

      datasets_week.push(dataset_week);
      datasets_week.push(dataset_week_t);
      

      title_op.text = 'Dias da Semana (Medias)';

      const chartConf_week: Chart.ChartConfiguration = {
        type: 'bar',
        data: {
          labels: labels_week,
          datasets: datasets_week
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: title_op,
          legend: {
            display: true,
            position: 'bottom',
            align: 'center',
            labels: {
              boxWidth: 10,
              usePointStyle: true
            }
          },
          scales: {
            yAxes: [{ticks: {beginAtZero: true}}]
          }
        }
      }

      if(this.weekBars){
        this.weekBars.destroy();
      }
      this.weekBars = new Chart(canvasbar2, chartConf_week)

    }
    this.$store.commit("setLoading",false);

  }
}
